import { render, staticRenderFns } from "./SwiperJob.vue?vue&type=template&id=50bfdafa&"
import script from "./SwiperJob.vue?vue&type=script&lang=js&"
export * from "./SwiperJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports